/**
 * Hook to get navigation items for the active persona context.
 * Each persona (Dirigeant, CISO, DPO, etc.) sees a curated set of modules.
 */

import { useJourneyStore } from '@/stores/useJourneyStore'
import { NAV_REGISTRY, commonNavItems, footerNavItems } from '@/config/nav-registry'
import type { NavItem } from '@/config/nav-registry'

interface ContextNav {
  /** Items shown at the top (common: dashboard, prestataires, dossiers, etc.) */
  commonItems: NavItem[]
  /** Context-specific items (middle section) */
  contextItems: NavItem[]
  /** Items shown at the bottom (reports, integrations, assistant IA) */
  footerItems: NavItem[]
}

export function useContextNavSections(): ContextNav {
  const activeContext = useJourneyStore((s) => s.activeContext)
  const contextItems = NAV_REGISTRY[activeContext] || NAV_REGISTRY['dirigeant']

  return {
    commonItems: commonNavItems,
    contextItems,
    footerItems: footerNavItems,
  }
}
